import MainView from 'js/views/main';

export default class View extends MainView {
  mount(): void {
    super.mount();

    const mailto = document.getElementById('mailto');

    if (mailto) {
      mailto.onclick = () => {
        this.track('Clicked invite mailto link');
      };
    }

    const showInvites = document.getElementById('show_invites');

    if (showInvites) {
      const showInvitesLink = document.querySelector('#show_invites a');
      const invites = document.getElementById('invites');
      if (!showInvitesLink || !invites) {
        throw new Error('Invites UI is broken');
      }
      (showInvitesLink as HTMLElement).onclick = (e) => {
        this.track('Opened invites section');

        showInvites.classList.add('hidden');
        invites.classList.remove('hidden');
        invites.classList.add('visible');

        e.stopPropagation();
        e.preventDefault();
        return false;
      };
    }
  }

  unmount(): void {
    super.unmount();
  }
}
